import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { ToSeoUrl } from '../../../../components/general/SeoUrl'
import DragDropFiles from '../../../../components/form/DragDropFiles'
import { fetchSliderContentGet } from '../../../../redux/slices/sliderContentGetSlice'
import { fetchSliderContentCreate } from '../../../../redux/slices/sliderContentCreateSlice'
import { fetchSliderContentUpdate } from '../../../../redux/slices/sliderContentUpdateSlice'

const CrudSliderContent = ({ showMenu, setShowMenu, setChanged, setSelectedItem, lang, id, selectedItem, t }) => {
    const [formData, setFormData] = useState({ files: [], sliderId: id, sort: 0 })
    const dispatch = useDispatch()

    const getData = async () => {
        if (selectedItem !== 0) {
            var data = await dispatch(fetchSliderContentGet({ id: selectedItem }))

            if (data.payload) {
                setFormData({
                    files: data.payload?.files,
                    titletr: data.payload?.title["tr"],
                    titleen: data.payload?.title["en"],
                    slugtr: data.payload?.slug["tr"],
                    slugen: data.payload?.slug["en"],
                    sliderId: id,
                    sort: data.payload?.sort || 0,
                })
            }
        }
    }

    const closeModal = () => {
        setFormData({ files: [], slugtr: "", slugen: "", titletr: "", titleen: "" })
        setShowMenu(false)
        setSelectedItem(0)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const title = { "tr": formData.titletr, "en": formData.titleen }
        const slug = { "tr": ToSeoUrl(formData.titletr), "en": ToSeoUrl(formData.titleen) }

        const filesToKeep = formData.files
            .filter(file => typeof file === 'string' || !file.file)
            .map(file => typeof file === 'string' ? file : file.preview);

        const newFiles = formData.files.filter(file => file.file);

        await dispatch(
            selectedItem === 0 ?
                fetchSliderContentCreate({ file: newFiles, title: title, slug: slug, sliderId: id, sort: formData.sort }) :
                fetchSliderContentUpdate({ id: selectedItem, filesToKeep: filesToKeep, file: newFiles, title: title, slug: slug, sliderId: id, sort: formData.sort })
        )
        setChanged(true)
        closeModal()
        getData()
        setShowMenu(false)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem, id, lang])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "slider_add" : "slider_edit")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    <DragDropFiles
                        formData={formData}
                        name={`files`}
                        setFormData={setFormData}
                        selectedItem={selectedItem}
                        title={t("images")}
                    />

                    <FormItem
                        id={`titletr`}
                        name={`titletr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("description")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titletr'
                    />
                    <FormItem
                        id={`titleen`}
                        name={`titleen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("description")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titleen'
                    />

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudSliderContent